module.exports = __webpack_public_path__ + "img/Slajd7.afb85679.jpeg";